<template>
    <others>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing" />
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Add University Marking</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-8">
                        <div class="col-span-8 sm:col-span-4">
                            <FormMultiselect
                                :required="true"
                                label="Course"
                                :options="courses"
                                track-key="title"
                                label-key="title"
                                return-key="id"
                                v-model="form.course_id"
                                :error="form.errors.course_id"
                                @change="form.course_year_id = ''"
                            />
                        </div>
                        <div class="col-span-8 sm:col-span-4">
                            <FormMultiselect
                                :required="true"
                                label="Course Year"
                                :options="filteredCourseYears"
                                track-key="title"
                                label-key="title"
                                return-key="id"
                                v-model="form.course_year_id"
                                :error="form.errors.course_year_id"
                            />
                        </div>
                        <div class="col-span-8 sm:col-span-4">
                            <FormMultiselect
                                :required="true"
                                label="Semester"
                                :options="semesters"
                                track-key="title"
                                label-key="title"
                                return-key="id"
                                v-model="form.semester_id"
                                :error="form.errors.semester_id"
                            />
                        </div>
                        <div class="col-span-8 sm:col-span-2">
                            <breeze-label :required="true" value="Internal Max Marks"/>
                            <breeze-input type="number" min="1" v-model="form.internal_max_marks" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.internal_max_marks:''" />
                        </div>
                        <div class="col-span-8 sm:col-span-2">
                            <breeze-label :required="true" value="External Max Marks"/>
                            <breeze-input type="number" min="1" v-model="form.external_max_marks" class="w-full"/>
                            <breeze-input-error :message="form.errors?form.errors.external_max_marks:''" />
                        </div>
                        <div class="col-span-8 sm:col-span-2">
                            <breeze-label value="Status"/>
                            <breeze-checkbox v-model:checked="form.status"/>
                            <breeze-input-error :message="form.errors?form.errors.status:''" />
                        </div>
                    </div>
                    <div class="flex items-center gap-4">
                        <breeze-button :disabled="form.processing">Submit</breeze-button>
                        <button-link :href="route('others.university-marking.list')">Back</button-link>
                    </div>
                    <exception />
                </form>
            </div>
        </div>
    </others>
</template>

<script>
import Others from '@/Pages/Others/Others'
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import BreezeInputError from '@/Components/InputError'
import BreezeButton from '@/Components/Button'
import BreezeCheckbox from '@/Components/Checkbox'
import ButtonLink from '@/Components/ButtonLink'
import Loading from '@/Components/Loading'
import Exception from '@/Components/Exception'
import FormMultiselect from '@/Components/Forms/FormMultiselect.vue'
import {useForm} from '@inertiajs/inertia-vue3'

export default {
    components: {
        Others,
        BreezeInput,
        BreezeLabel,
        BreezeInputError,
        BreezeButton,
        BreezeCheckbox,
        ButtonLink,
        Loading,
        Exception,
        FormMultiselect,
    },
    props: ['courses', 'courseYears', 'semesters'],
    data() {
        return {
            form: useForm({
                course_id: '',
                course_year_id: '',
                semester_id: '',
                internal_max_marks: '',
                external_max_marks: '',
                status: true,
            }),
        }
    },
    computed: {
        filteredCourseYears() {
            if (! this.form.course_id) {
                return this.courseYears;
            }

            return this.courseYears.filter((courseYear) => Number(courseYear.course_id) === Number(this.form.course_id));
        },
    },
    methods: {
        submitForm() {
            this.form.post(route('others.university-marking.store'));
        },
    },
}
</script>
